var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('EducateNormal',{attrs:{"type":"1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }